import styled from "styled-components";

export const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(20, 26, 38, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

export const Card = styled.div`
    background: #FFFFFF;
    border-radius: 14px;
    width: 100%;
    max-width: 520px;
    box-shadow: 0 12px 40px rgba(20, 26, 38, 0.22);
    font-family: Mulish;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 22px;
    border-bottom: 1px solid #EEF1F6;
`;

export const Title = styled.h3`
    margin: 0;
    font-size: 1.05rem;
    font-weight: 800;
    color: #2B3240;
`;

export const CloseBtn = styled.button`
    border: none;
    background: #EEF1F6;
    color: #9AA4B2;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1rem;
`;

export const Body = styled.div`
    padding: 20px 22px 22px;
`;

export const Label = styled.div`
    font-size: 0.85rem;
    font-weight: 700;
    color: #2B3240;
    margin-bottom: 8px;
`;

export const LinkRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background: #EDF2FB;
    border-radius: 10px;
    padding: 4px 4px 4px 14px;
`;

export const LinkText = styled.a`
    flex: 1;
    color: #2F80ED;
    font-size: 0.9rem;
    text-decoration: underline;
    word-break: break-all;
`;

export const CopyBtn = styled.button`
    border: none;
    background: #2F80ED;
    color: #FFFFFF;
    width: 38px;
    height: 38px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1.05rem;
    flex-shrink: 0;
`;

export const Copied = styled.span`
    display: inline-block;
    margin-top: 8px;
    font-size: 0.78rem;
    font-weight: 700;
    color: #27AE60;
`;

export const Advanced = styled.button`
    margin-top: 18px;
    border: none;
    background: transparent;
    color: #6B7280;
    font-family: Mulish;
    font-size: 0.82rem;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
`;
